import { AxiosResponse, AxiosError, AxiosPromise } from 'axios'

const parseResult = (response: AxiosResponse) => (response?.data ? response.data : response)

type TRequestResult<ReturnType> = {
    data: ReturnType | null
    error: AxiosError | {} | null
}

type TAsyncRequestResult<ReturnType> = Promise<TRequestResult<ReturnType>>

const resolveRequest = async <ReturnType>(
    requestPromise: AxiosPromise,
    retries = 1
): TAsyncRequestResult<ReturnType> => {
    const result: TRequestResult<ReturnType> = { data: null, error: null }
    let retryCount = 0;
    let error;
    while (retryCount < retries) {
        try {
            const response: AxiosResponse = await requestPromise
            result.data = parseResult(response)
            return result;
        } catch (err) {
            retryCount++;
            error = err;
        }
    }
    if (retryCount === retries) {
        return { data: null, error: error };
    }

}

export type { TRequestResult, TAsyncRequestResult }
export { resolveRequest }
